import { type RouterOutput } from '@/config/trpc'
import { type PlatformType } from '@backend/lib/db/schema/platform'

type ScheduledPost = RouterOutput['scheduledPost']['list'][number]

export interface Event {
  id: string
  title: string
  date: Date
  time: string
  platform: PlatformType
  platformColor: string
  status?: 'draft' | 'scheduled' | 'publishing' | 'published' | 'failed' | 'imported'
  source?: 'scheduled' | 'tracked'
  postId?: number
  /** tracked_post row id — set for tracked events, drives "Remove from CASSI". */
  trackedPostId?: number
  postContent?: ScheduledPost['postContent']
  link?: string | null
  mediaUrl?: string | null
  /**
   * Full caption text. Set for tracked posts, where `title` is only the first
   * five words and the fallback preview has nothing else to show.
   */
  caption?: string | null
}

/**
 * Get display name for a platform (capitalized)
 */
export function getPlatformDisplayName(platform: PlatformType): string {
  switch (platform) {
    case 'instagram':
      return 'Instagram'
    case 'linkedin':
      return 'LinkedIn'
    case 'tiktok':
      return 'TikTok'
    case 'youtube':
      return 'YouTube'
    case 'facebook':
      return 'Facebook'
    case 'meta-ads':
      return 'Meta Ads'
    default:
      return platform
  }
}
